var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1603,
    height: 145,
    viewBox: "0 0 1603 145",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M128.591 140.639V119.889H66.5963C60.2771 119.889 53.9199 118.592 48.6437 115.114C11.428 90.5856 20.3166 46.8549 47.9826 30.8703C53.6398 27.6017 60.3137 26.9 66.8472 26.9H130.783V4.61328H62.6477C57.4476 4.61328 52.2822 5.4593 47.3538 7.11819C19.3621 16.5402 1.07753 43.4586 2.63531 72.9524L3.17552 83.1801C4.36075 105.62 18.2997 125.396 39.0353 134.057C49.4387 138.402 60.601 140.639 71.8753 140.639H128.591Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M175.353 141.408H151.973L216.268 4.61328H235.264L299.56 141.408H276.18L225.766 30.8902L175.353 141.408Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M718.941 141.408H695.561L759.856 4.61328H778.852L843.148 141.408H819.768L769.354 30.8902L718.941 141.408Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M926.438 141.408V60.8944H950.461V64.8028H1047.23V85.1266H950.461V141.408H926.438Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1050.15 26.1315H926.438V4.61328H1050.15V26.1315Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1105.44 4.61328H1085.71V141.408H1197.5V120.658H1105.44V4.61328Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1448.28 136.386L1396.96 8.45582H1418.88L1457.18 109.531C1457.83 111.258 1460.28 111.251 1460.92 109.52L1496.27 14.5929C1497.55 11.1312 1502.45 11.117 1503.76 14.5711L1539.23 108.19C1539.89 109.917 1542.33 109.91 1542.98 108.179L1580.57 7.11681L1603 8.45582L1550.24 136.456C1549.01 139.452 1546.09 141.408 1542.85 141.408H1535.57C1532.19 141.408 1529.18 139.284 1528.04 136.102L1500.91 60.2417C1500.6 59.361 1499.35 59.3562 1499.03 60.2345L1471.22 136.16C1470.06 139.312 1467.06 141.408 1463.71 141.408H1455.71C1452.44 141.408 1449.5 139.42 1448.28 136.386Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M357.281 141.406H333.9V66.8606H357.281V73.7771H418.978C431.711 73.7771 442.034 63.455 442.034 50.7219C442.034 37.9888 431.711 27.6667 418.978 27.6667H333.9V6.14844H416.432C441.622 6.14844 461.807 27.0062 460.982 52.1824C460.194 76.2182 440.481 95.2954 416.432 95.2954H357.281V141.406Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M515.827 6.14844H496.1V141.406H515.827V6.14844Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M607.156 27.6667H555.281V6.14844H680.949V27.6667H629.805V141.406H607.156V27.6667Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M1375.04 72.2397C1375.04 112.137 1341.35 144.479 1299.79 144.479C1258.23 144.479 1224.53 112.137 1224.53 72.2397C1224.53 32.3428 1258.23 0 1299.79 0C1341.35 0 1375.04 32.3428 1375.04 72.2397ZM1247.88 72.2397C1247.88 99.7574 1271.12 119.119 1299.79 119.119C1328.45 119.119 1351.69 99.7574 1351.69 72.2397C1351.69 44.7221 1328.45 23.8237 1299.79 23.8237C1271.12 23.8237 1247.88 44.7221 1247.88 72.2397Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.7f8d38560172a7ba50fc25550c8b0426.svg";
export { ForwardRef as ReactComponent };